import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'joinClassNames',
    standalone: true,
})
export class JoinClassNamesPipe implements PipeTransform {
    public transform(classes: string[]): string {
        return classes.filter((str) => str).join(' ');
    }
}
